import _objectSpread from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { ref, onBeforeMount } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    api: Function,
    params: Object
  },
  emits: ['update:tableData'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
        emit = _ref.emit;
    var props = __props;
    var tableData = ref({
      data: [],
      total: 0
    });
    var queryData = ref({
      pageNum: 1,
      pageSize: 10
    });
    var tableLoading = ref(false);
    expose({
      getData: getData
    });
    onBeforeMount(function () {
      getData();
    });

    function getData(params) {
      tableLoading.value = true;
      props.api(_objectSpread(_objectSpread(_objectSpread({}, params), props.params), queryData.value)).then(function (_ref2) {
        var data = _ref2.data;
        tableData.value = data || {};
        emit('update:tableData', data);
      }).finally(function () {
        tableLoading.value = false;
      });
    }

    function handleCurrentChange(current) {
      queryData.value.pageNum = current; // 滑动去顶端

      document.documentElement.scrollTop = 0;
      getData();
    }

    return function (_ctx, _cache) {
      var _component_el_table = _resolveComponent("el-table");

      var _component_el_pagination = _resolveComponent("el-pagination");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value.data,
        style: {
          "width": "100%"
        },
        "empty-text": "No records found",
        "header-cell-style": {
          background: '#F5F5F7',
          paddingTop: '20px',
          paddingBottom: '20px'
        }
      }, {
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["data"])), [[_directive_loading, tableLoading.value]]), _createVNode(_component_el_pagination, {
        class: "table-pagination",
        background: "",
        layout: "prev, pager, next",
        "default-current-page": "1",
        onCurrentChange: handleCurrentChange,
        total: tableData.value.total
      }, null, 8, ["total"])], 64);
    };
  }
});